module.exports = __webpack_public_path__ + "static/media/platinum-partner3.efc06dda.png";